<template>
  <div>
    <div id="fullpage">
      <!-- 第二页 -->
      <div class="section section1">
        <div class="page1">
          <div class="content">
            <!-- 左边文字部分 -->
            <img class="bg_img" src="@/assets/img/bg_a.png" />
            <div class="text_box">
              <h1 class="title animated-content-left">
                重庆市九吨科技有限公司
              </h1>
              <!--  <p class="en_title animated-content-left">
                Chongqing Jiuton Technology Co., LTD
              </p> -->
              <div
                class="icon_origin mar-bottom150 animated-content-left"
              ></div>
              <p class="content_text animated-content-left">
                九吨科技秉承着“善良正直、务实担当、创新进取、追求极致”的创业理念，打造了一家年轻有活力的科技型创新企业。
              </p>
            </div>
            <!-- 右边图片展示 -->
            <div class="img_box">
              <img
                :class="
                  index % 2 == 0 ? 'animated-content-top' : 'animated-content'
                "
                :src="item.resource"
                v-for="(item, index) in imageList"
                :key="index"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 第一页 -->

      <!-- 第四页 -->
      <div class="section section2">
        <div class="page2">
          <div class="content" :key="listIndex">
            <!-- 左边文字部分 -->
            <div class="text_box">
              <div class="mar-bottom75 title_box">
                <img
                  class="bg_boss"
                  :src="managerList[listIndex].extends.background"
                />
                <h1 class="title_name animated-content-rigth">
                  {{ managerList[listIndex].title }}
                </h1>
                <p class="title_introduce animated-content-rigth">
                  {{ managerList[listIndex].subTitle }}
                </p>
                <div class="icon_origin animated-content-rigth"></div>
              </div>
              <p class="content_text animated-content-rigth">
                {{ managerList[listIndex].desc }}
              </p>
              <!-- <p class="content_text animated-content-rigth">
                公司开发的包括新晴天气、手写输入法等在内优秀互联网产品，累计营业额超3亿多人民币。
              </p> -->
            </div>
            <!-- 右边图片展示 -->
            <div class="img_box animated-content">
              <img
                :class="'boss_img_' + listIndex"
                :src="managerList[listIndex].resource"
              />
              <img
                class="about_nineton_img"
                src="@/assets/img/about_nineton.png"
              />
            </div>
            <!-- 切换列表 -->
            <div class="boss_list animated-content-top">
              <img
                :src="item.extends.face"
                v-for="(item, index) in managerList"
                @click="changeListIndex(index)"
                :key="index"
                style="cursor: pointer"
              />
              <!--               <img src="@/assets/img/boss_small.png" />
              <img src="@/assets/img/boss_small.png" /> -->
            </div>
          </div>
        </div>
      </div>

      <div class="section section3">
        <div class="page3">
          <img class="map_bg" src="@/assets/img/map.png" />
          <Vuehorizontaltimeline
            :items="nodeList"
            class="time_box"
            @mouseenter.native="clearTime"
            @mouseleave.native="addTime"
          />
        </div>
      </div>
    </div>

    <div class="xiahua" v-if="nowIndex != 2">
      <p v-if="someData == '1' && page_name == 'index'">
        <img @click="changeIndex" src="@/assets/img/xiahua.svg" />
      </p>
      <p v-else>
        <img @click="changeIndex" src="@/assets/img/xiahua_00.svg" />
      </p>
    </div>
  </div>
</template>

<script>
import fullpage from "fullpage.js";
import BounceElement from "@/components/BounceElement";
import { mapGetters, mapActions } from "vuex";
// import { swiper.css, SwiperSlide } from 'vue-awesome-swiper'
import Vuehorizontaltimeline from "@/components/VueHorizontalTimeline.vue";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import "../../assets/css/base.less";

export default {
  components: {
    Vuehorizontaltimeline,
    BounceElement,
  },
  data() {
    return {
      fillpage: null,
      items: [
        {
          title: "九吨科技成立",
          time_span: "2023-01-01",
        },
        {
          title: "两款核心产品“天气”和“黄历”的日活达到",
          time_span: "2023-02-14",
        },
        {
          title: "懒猫试玩App上线",
          time_span: "2023-03-20",
        },
        {
          title: "懒猫试玩App上线",
          time_span: "2023-03-20",
        },
        {
          title: "懒猫试玩App上线",
          time_span: "2023-03-20",
        },
        {
          title: "懒猫试玩App上线",
          time_span: "2023-03-20",
        },
        {
          title: "懒猫试玩App上线",
          time_span: "2023-03-20",
        },
        {
          title: "懒猫试玩App上线",
          time_span: "2023-03-20",
        },
        {
          title: "敬请期待更多佳绩...",
        },
      ],
      title_id: 1,
      nodeList: [],
      managerList: [
        {
          desc: "",
          resource: "",
          resourceType: "",
          sort: "",
          subTitle: "",
          title: "",
          extends: {
            face: "",
            background: "",
          },
        },
      ],
      imageList: [],
      listIndex: 0,
      // 滚动动画
      timer: null,
      nowIndex: null,
    };
  },
  watch: {
    $route: {
      handler: function (val) {
        this.fillpage
          ? this.fillpage.moveTo(
              this.$route.query.page ? this.$route.query.page : 1
            )
          : "";
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.updateSomeData("1");
    // 获取公司简介
    this.getculture();
    // 获取大事件
    this.getNode();
    // 获取管理团队
    this.getManager();
    this.scrollContainer = document.getElementById("scrollBoxTime");
    this.scrollPosition = 0;
    this.animationFrameId = null;
    this.initSwiper();
    this.initFullPage();
    this.fillpage.moveTo(this.$route.query.page ? this.$route.query.page : 1);
  },

  // 销毁fullpage
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    if (this.fillpage) {
      this.fillpage.destroy("all");
    }
  },
  methods: {
    ...mapActions(["updateSomeData"]),
    ...mapActions(["updatePageName"]),
    initFullPage() {
      let _this = this;
      this.fillpage = new fullpage("#fullpage", {
        // sectionsColor: ['#f0f0f0', '#4BBFC3', '#7BAABE', 'whitesmoke', '#000'],
        // navigationTooltips: ['Section 1', 'Section 2', 'Section 3', 'Section 4', 'Section 5'],
        // anchors: ['section1', 'section2', 'section1', 'section2', 'section5'],
        // menu: '#menu',
        onLeave: function (origin, destination, direction) {
          // 如果离开的 section 包含动画内容，移除动画类
          /*           if (origin.item.querySelector(".animated-content")) {
            origin.item
              .querySelector(".animated-content")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-left")) {
            origin.item
              .querySelector(".animated-content-left")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-top")) {
            origin.item
              .querySelector(".animated-content-top")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-rigth")) {
            origin.item
              .querySelector(".animated-content-rigth")
              .classList.remove("active");
          } */
          /* let animatedElements = origin.item.querySelectorAll(
            ".animated-content, .animated-content-left, .animated-content-top, .animated-content-rigth"
          );
          // 为每个元素移除动画类
          animatedElements.forEach((element) => {
            element.classList.remove("active");
          }); */
          if (destination.index - 1 == 2 || destination.index + 1 == 2) {
            clearInterval(_this.timer);
            _this.timer = null;
          }
        },

        afterLoad: function (origin, destination, direction) {
          _this.nowIndex = destination.index;
          // 如果进入的 section 包含动画内容，添加动画类
          /* if (origin.item.querySelector(".animated-content")) {
            origin.item
              .querySelector(".animated-content")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-left")) {
            origin.item
              .querySelector(".animated-content-left")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-top")) {
            origin.item
              .querySelector(".animated-content-top")
              .classList.remove("active");
          }
          if (origin.item.querySelector(".animated-content-rigth")) {
            origin.item
              .querySelector(".animated-content-rigth")
              .classList.remove("active");
          } */
          // 找出加载的 section 中所有可能的动画元素
          /* let animatedElements = destination.item.querySelectorAll(
            ".animated-content, .animated-content-left, .animated-content-top, .animated-content-rigth"
          );

          // 为每个元素添加动画类
          animatedElements.forEach((element) => {
            element.classList.add("active");
          }); */
          if (destination.index == 2) {
            /* _this.timer = setInterval(() => {
              const scrollBox = document.getElementById("scrollBoxTime");
              const containerWidth = scrollBox.clientWidth;
              // 获取滚动内容宽度
              const contentWidth = scrollBox.scrollWidth;
              if (scrollBox.scrollLeft + containerWidth >= contentWidth) {
                scrollBox.scrollTo(0, 0);
              } else {
                const scrollDistance = containerWidth * 0.0008;
                scrollBox.scrollBy({
                  left: scrollDistance,
                  behavior: "smooth",
                });
              }
            }, 80); */
            /*  const scrollWidth = _this.scrollContainer.scrollWidth;
            const containerWidth = _this.scrollContainer.clientWidth;
            if (scrollWidth > containerWidth) {
              if (_this.animate || _this.hoverFlag) {
                return;
              }
              const endPosition = scrollWidth - containerWidth;
              const increment = 1;
              _this.animate = () => {
                _this.scrollPosition += increment;
                if (_this.scrollPosition > endPosition) {
                  _this.scrollPosition = 0; // 将滚动位置重置为0
                }
                _this.scrollContainer.scrollLeft = _this.scrollPosition;
                if (_this.scrollPosition < endPosition) {
                  _this.animationFrameId = requestAnimationFrame(_this.animate);
                } else {
                  _this.scrollPosition = 0; // 将滚动位置重置为0并继续滚动
                  _this.animationFrameId = requestAnimationFrame(_this.animate);
                }
              };

              _this.animationFrameId = requestAnimationFrame(_this.animate);
            } else {
              _this.scrollPosition = 0;
            } */
            // console.log(_this.timer);
          }
        },
        // 其他fullpage配置项...
      });
    },
    initSwiper() {
      new Swiper(".swiper", {
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
    changeImg(id) {
      this.title_id = id + 1;
    },
    // 插件路由
    navigateToSection(sectionIndex) {
      this.fillpage.moveTo(sectionIndex);
    },
    // 获取公司简介
    async getculture() {
      const [err, res] = await this.$http.get("culture");
      if (err) {
        return;
      }
      this.culture = res;
      let imageList = [];
      res.list.forEach((item) => {
        if (item.resourceType == "image") {
          imageList.push(item);
        }
      });
      this.imageList = imageList;
    },
    // 获取管理团队
    async getManager() {
      const [err, res] = await this.$http.get("manager");
      if (err) {
        return;
      }
     /*  this.managerList = res.list;
      const response = await fetch("/manager.json");
      const data = await response.json(); */
      this.managerList = res.list;
    },
    // 获取公司大事件
    async getNode() {
      const [err, res] = await this.$http.get("node");
      if (err) {
        return;
      }
      this.nodeList = res.list;
    },
    changeListIndex(index) {
      if (index == this.listIndex) {
        return;
      }
      if (document.querySelector(".fp-completely").classList) {
        document.querySelector(".fp-completely").classList.remove("active");
      }
      this.backPageTimer = setTimeout(() => {
        if (document.querySelector(".fp-completely").classList) {
          document.querySelector(".fp-completely").classList.add("active");
        }
      }, 10);
      this.$nextTick(() => {
        this.listIndex = index;
      });
    },
    // 滚动
    changeIndex() {
      this.fillpage.moveSectionDown();
    },
    // app按钮的移入移出
    clearTime() {
      /* if (this.animate) {
        this.hoverFlag = true;
        window.cancelAnimationFrame(this.animationFrameId);
        this.animate = null;
      } */
    },
    addTime() {
      /*  this.hoverFlag = false;
      const scrollWidth = this.scrollContainer.scrollWidth;
      const containerWidth = this.scrollContainer.clientWidth;
      if (scrollWidth > containerWidth) {
        const endPosition = scrollWidth - containerWidth;
        const increment = 1;
        if (this.animate) {
          return;
        }
        this.animate = () => {
          this.scrollPosition += 1;
          if (this.scrollPosition > endPosition) {
            this.scrollPosition = 0; // 将滚动位置重置为0
          }
          this.scrollContainer.scrollLeft = this.scrollPosition;
          if (this.scrollPosition < endPosition) {
            this.animationFrameId = requestAnimationFrame(this.animate);
          } else {
            this.scrollPosition = 0; // 将滚动位置重置为0并继续滚动
            this.animationFrameId = requestAnimationFrame(this.animate);
          }
        };

        this.animationFrameId = requestAnimationFrame(this.animate);
      } else {
        this.scrollPosition += 2;
        this.nodeList = [...this.nodeList, ...this.nodeList];
        this.scrollPosition = 0;
      } */
    },
  },
  computed: {
    ...mapGetters(["someData"]),
    ...mapGetters(["page_name"]),
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.less";

.has-step-green {
  font-size: 19px;
}
.has-color-red {
  font-size: 18px;
}
.png18 {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.section1 {
  .page1 {
    position: relative;
    height: 100vh;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    .content {
      padding: 164px 158px 0 237px;
      display: flex;
      justify-content: space-between;
      .media1();
      .bg_img {
        position: absolute;
        right: 80px;
        bottom: 73px;
        width: 811px;
        height: 181px;
      }
      .text_box {
        position: relative;
      }
      .title {
        font-size: 41px;
        font-weight: 600;
        color: #000000;
        line-height: 57px;
        margin-top: 60px;
        font-family: "PingFang_Medium";
      }
      .content_text {
        font-size: 20px;
        color: #666666;
        width: 659px;
      }
    }
    .img_box {
      display: flex;
      justify-content: space-between;
      width: 815px;
      img {
        height: 603px;
        width: 191px;
      }
    }
  }
}

.section2 {
  .page2 {
    position: relative;
    height: 100vh;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    .content {
      padding: 164px 158px 0 237px;
      .media1();
      height: 700px;
      display: flex;
      justify-content: space-between;
    }
    .text_box {
      padding-top: 65px;
      width: 759px;
      .title_box {
        position: relative;
        .bg_boss {
          height: 264px;
          position: absolute;
          top: -50%;
          left: 0;
        }
      }
      .title_name {
        font-size: 41px;
        font-weight: 600;
        color: #000000;
        line-height: 57px;
        font-family: "PingFang_Medium";
      }
      .title_introduce {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        margin-bottom: 20px;
      }
      .content_text {
        font-size: 20px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        line-height: 35px;
      }
    }
    .img_box {
      margin-left: -70px;
      width: 739px;
      position: relative;
      .boss_img_0 {
        position: relative;
        width: 657px;
        height: 891px;
        z-index: 20;
        top: 22px;
      }
      .boss_img_1 {
        position: relative;
        width: 657px;
        height: 891px;
        z-index: 20;
        top: 22px;
      }
      .boss_img_2 {
        position: relative;
        width: 608px;
        height: 825px;
        top: 88px;
        left: 60px;
        z-index: 20;
      }
      .about_nineton_img {
        width: 458px;
        height: 825px;
        position: absolute;
        right: 10px;
        top: 0;
        z-index: 10;
      }
    }
    .boss_list {
      // display: flex;
      width: 141px;
      z-index: 9999;
      img {
        height: 141px;
        width: 141px;
        margin-top: 52px;
        &:first-child {
          margin-top: 150px;
        }
      }
    }
  }
}
.section3 {
  .page3 {
    height: 100vh;
    width: 1800px;
    position: relative;
    margin: 0 auto;
    // margin: 0 auto;
    .map_bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .time_box {
      position: absolute;
      width: 1800px;
      height: 500px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.xiahua {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999999;
  img {
    cursor: pointer;
  }
}
.bounce {
  animation: bounce 1s infinite;
}
</style>
